import { useFormContext } from 'react-hook-form'

export const useFormError = (name: string) => {
  const { formState } = useFormContext()
  return formState.errors[name]
}
